import { render, staticRenderFns } from "./dyShopping.vue?vue&type=template&id=003b6ccf&"
import script from "./dyShopping.vue?vue&type=script&lang=js&"
export * from "./dyShopping.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports